/**
 * Public guest-facing site origin for copy URL / QR / preview links.
 * Prefer `VITE_FRONTEND_URL`; fall back to current origin in local/dev.
 */
export function getPublicFrontendBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_FRONTEND_URL?.trim().replace(/\/+$/, '');
  if (fromEnv) {
    return fromEnv;
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return '';
}
